import { Field, Form, Formik } from 'formik';
import Segment from './segment';
import { requiredTermsAndConditions } from './forms/validations';
import Button from './buttons/button';
import Alert from './alert';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';
import { useCreateStudentMutation } from '../../hooks/react-query/use-student';
import { CreateStudentDataType, StudentType } from '../../api/student';
import { Link } from 'react-router-dom';
import FormCheckbox from './forms/checkbox';

type CreateStudentFormDataType = CreateStudentDataType & {
  termsAndConditions: boolean;
};
type CreateStudentFormPropsType = {
  onSubmit?: (data: StudentType) => void;
};

function CreateStudentForm({ onSubmit }: CreateStudentFormPropsType) {
  const { formErrorMessage, setFormError } = useFormErrorMessage();
  const { mutate: createStudent } = useCreateStudentMutation();

  async function submit({ termsAndConditions, ...createStudentData }: CreateStudentFormDataType) {
    await createStudent(createStudentData, {
      onSuccess: onSubmit,
      onError: setFormError
    });
  }

  return (
    <Segment dataTestId='create-student-form' className='p-6'>
      <Formik initialValues={{ notify: false, termsAndConditions: false }} onSubmit={submit}>
        {({ dirty }: { dirty: boolean }) => (
          <>
            {dirty && formErrorMessage && (
              <Alert content={formErrorMessage} className='mt-3 mb-5' />
            )}

            <Form noValidate data-testid='login-form' className='grid grid-cols-1 gap-5 py-3'>
              <Field
                name='notify'
                label={
                  <>
                    مایل به دریافت
                    <span className='font-medium'> پیامک‌های اطلاع رسانی </span>
                    سامانه آزمون‌های مدمشاور شامل
                    <span className='font-medium'> آزمون‌های جدید</span>،
                    <span className='font-medium'> پکیج‌های جدید </span>و
                    <span className='font-medium'> کدهای تخفیف </span>
                    هستم.
                  </>
                }
                component={FormCheckbox}
              />
              <Field
                required
                name='termsAndConditions'
                label={
                  <>
                    <Link to='/terms-and-conditions' target='_blank' className='text-indigo-600'>
                      شرایط و قوانین{' '}
                    </Link>
                    <span>را مطالعه کرده‌ام و آن‌ها را می‌پذیرم.</span>
                  </>
                }
                component={FormCheckbox}
                validate={requiredTermsAndConditions}
              />
              <Button type='submit' color='green' content='تایید' />
            </Form>
          </>
        )}
      </Formik>
    </Segment>
  );
}

export default CreateStudentForm;
